export function useSessionStorage() {
  const getSessionStore = <T>(key: string, fallback: T): T => {
    try {
      const stored = sessionStorage.getItem(key);
      return stored ? (JSON.parse(stored) as T) : fallback;
    } catch {
      return fallback;
    }
  };

  const setSessionStore = (key: string, value: string): void => {
    sessionStorage.setItem(key, value);
  };

  const clearSessionStore = (key: string): void => {
    sessionStorage.removeItem(key);
  };

  return { getSessionStore, setSessionStore, clearSessionStore };
}
